import {
  Controller
} from "@hotwired/stimulus";

export default (function() {
  var _Class;

  _Class = class extends Controller {
    connect() {
      return console.log('Hello from CoffeeScript Stimulus controller');
    }

    greet() {
      var now;
      now = new Date().toLocaleTimeString();
      if (this.hasOutputTarget) {
        return this.outputTarget.textContent = `Olá às ${now}`;
      } else {
        return console.log(`Olá às ${now}`);
      }
    }

  };

  _Class.targets = ['output'];

  return _Class;

}).call(this);
